
import { Component, Mixins } from 'vue-property-decorator'
import scroll from '@/mixins/scroll'
import GoodsCard from '@/views/industryMall/shop/template/GoodsCard.vue'
import { BannerImgListDto, isOptionalGoods } from '@/api/shoppingMall'
import {
  getCyStoreGoodsList,
  getStoreDtlBy,
  cancelFollowStore,
  followStore,
  ShopGoodsInfoDto,
  getStoreShoppingCart
} from '@/api/industryMall'
import { Getter } from 'vuex-class'

@Component({
  name: 'ShopMallInfo',
  components: { GoodsCard }
})
export default class ShopMallInfo extends Mixins(scroll) {
  @Getter companyId!: string
  @Getter providerId!: string
  @Getter partnerCompanyId!: string

  goodsList: ShopGoodsInfoDto[] = []
  bannerList: BannerImgListDto[] = []
  params = {
    pageIndex: 1,
    pageSize: 20,
    // 店铺编号
    storeId: '',
    // 合作方企业编号
    partnerCompanyId: '',
    // 商品编号
    goodsId: '',
    // 搜索关键字
    keyword: '',
    companyId:''
  }
  refreshing = false
  loading = false
  finished = false
  // 样式省略号显示
  toShow = true

  // 店铺信息
  storeInfo: { [x: string]: any } = {}

  // 瀑布流数据
  Hs = [0, 0]
  gap = 10
  nodes = []
  fragElement = null

  /**
   * 初始化瀑布流
   */
  fragInit() {
    this.nodes = Array.from(document.getElementsByClassName('goods-list'))
    this.Hs = [0, 0]
    this.fragElement = document.createDocumentFragment()
    this.reset()
  }

  /**
   * 瀑布流重排
   */
  reset() {
    this.nodes.forEach((item) => {
      // 获取高度小的一边
      let tag = this.Hs.indexOf(Math.min(...this.Hs))
      item.style.position = 'absolute'
      item.style.top = this.Hs[tag] + 'px'
      item.style.left = tag * (item.offsetWidth + this.gap) + 'px'
      // 增加高度距离
      this.Hs[tag] += item.offsetHeight + this.gap
      this.fragElement.appendChild(item)
    })
    let frag = this.Hs.indexOf(Math.max(...this.Hs))
    // @ts-ignore
    document.getElementsByClassName('lists')[0].style.height =
      this.Hs[frag] + 'px'
    // 插入文档中
    document.getElementsByClassName('lists')[0].appendChild(this.fragElement)
  }

  /**
   * 页面重排
   */
  reloadPage() {
    this.$nextTick(() => {
      this.fragInit()
    })
  }

  activated() {
    if (this.$route.query.storeId !== this.params.storeId) {
      this.goodsList = []
      this.init()
    } else {
      if (window.sessionStorage.getItem('refresh') === '1') {
        window.sessionStorage.setItem('refresh', '0')
        this.init()
      }
      this.$setScrollY()
      this.refreshShoppingGoodsCount()
    }
  }

  created() {
    this.init()
  }

  mounted() {
    this.$addScrollListener('.shop-info')
  }

  deactivated () {
    this.$removeScrollListener()
  }

  refreshShoppingGoodsCount () {
    console.log('*-9', this.partnerCompanyId)
    getStoreShoppingCart({
      partnerCompanyId: this.partnerCompanyId,
      pageIndex: 1,
      pageSize: 100
    }).then((res) => {
      const shoppingGoods = []
      res.data.records.forEach(shop => {
        shoppingGoods.push(...shop.goodsPackageList)
      })
      const goods = []
      shoppingGoods.forEach(good => {
        if (Number(good.isValid)) {
          goods.push({
            goodsId: good.goodsId,
            packageId: good.packageId,
            orderQuantity: Number(good.orderQuantity),
            goodsName: good.goodsName
          })
        }
      })
      this.goodsList.forEach(good => {
        if (!good.isMultiSpec) {
          good.packageList.forEach((pack: any, packIndex) => {
            const targetGood = goods.find(id => id.goodsId === pack.goodsId && id.packageId === good.packageList[packIndex].packageId)
            if (targetGood) {
              good.packageList[packIndex].orderQuantity = targetGood.orderQuantity
            } else {
              // 购物车删除的商品
              good.packageList[packIndex].orderQuantity = 0
            }
          })
        }
      })
    })
  }

  init() {
    // this.params.customerId = this.companyId
    // this.params.shopId = this.providerId
    this.params.storeId = this.$route.query.storeId as string
    this.params.companyId = this.companyId
    this.getGoodsList()
    this.getStoreDtl()
  }

  getStar() {
    const param = {
      storeId: this.storeInfo.storeId,
      companyId: this.companyId
    }
    if (this.storeInfo.isFollow === '0') {
      followStore(param).then(() => {
        this.getStoreDtl()
      })
    } else {
      this.$dialog
        .confirm({
          message: `确定取消店铺关注？`
        })
        .then(() => {
          console.log('确定')
          cancelFollowStore(param).then(()=> {
            this.getStoreDtl()
          })
        })
        .catch(() => {
          console.log('取消')
        })
    }
  }

  /**
   * @description 获取产业商城信息
   * @param companyId
   */
  getStoreDtl() {
    getStoreDtlBy({ storeId: this.params.storeId,companyId:this.companyId }).then((res) => {
      console.log('res', res)
      this.storeInfo = res.data[0]
    })
  }

  /**
   * 下拉刷新
   * */
  onRefresh() {
    this.params.pageIndex = 1
    this.refreshing = true
    this.init()
  }

  /**
   * 上拉加载更多
   * */
  onLoad() {
    this.loading = true
    this.params.pageIndex++
    this.getGoodsList()
  }

  /**
   * 获取商品列表
   */
  getGoodsList() {
    getCyStoreGoodsList(this.params)
      .then((res) => {
        if (this.refreshing) {
          this.goodsList = []
        }
        this.goodsList = this.goodsList.concat(res.data.records)
        if (this.params.pageIndex >= res.data.totalPages) {
          this.finished = true
        } else {
          this.finished = false
        }
      })
      .catch(() => {
        this.finished = true
      })
      .finally(() => {
        this.reloadPage()
        this.refreshing = false
        this.loading = false
      })
  }

  reloadList() {
    this.params.pageIndex = 1
    this.goodsList = []
    this.getGoodsList()
  }

  goBack() {
    this.$router.back()
  }

  /**
   * 搜索历史记录
   */
  toSearchHistory() {
    this.$router.push({
      path: '/ShopSearchHistory',
      query: {
        searchType: '3',
        storeId: this.$route.query.storeId
      }
    })
  }
}
